<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Master Dosen Mata Pelajaran</h1>
          </div>
          <div class="toolbar">
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal-tambah></ButtonComponent>
          </div>
        </div>

        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-row style="margin-top: 20px;">
                <v-col>
                  <SelectBidangStudi></SelectBidangStudi>
                </v-col>
                <v-col>
                  <SelectMataKuliah></SelectMataKuliah>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <SelectMataPelajaran></SelectMataPelajaran>
                </v-col>
              </v-row>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="dosenMatpel.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="dosenMatpel.headers" :items="dosenMatpel.desserts" :search="dosenMatpel.search">
                <template v-slot:item.action="{ item }">
                  <ButtonComponent v-b-modal.modal-edit name="edit" colors="#3751E4"></ButtonComponent>
                  <ButtonComponent colors="#EF4848" name="hapus"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
          <!-- <template v-slot:html>
            {{ dosenMatpel.html }}
          </template>
          <template v-slot:js>
            {{ dosenMatpel.js }}
          </template> -->
        </KTCodePreview>

        <b-modal id="modal-tambah" size="lg" title="Tambah Dosen Mata Pelajaran" ok-title="Simpan" ok-variant="primary"
          cancel-title="Batal" cancel-variant="danger">
          <b-form>
            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Bidang Studi">
                  <b-form-input id="tambahBidangStudi" type="text" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Mata Kuliah">
                  <b-form-input id="tambahMataKuliah" type="number" required></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Mata Pelajaran">
                  <b-form-input id="tambahMataPelajaran" type="text" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Nama Dosen">
                  <SelectDosen></SelectDosen>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Status Dosen">
                  <b-form-radio-group id="pilihStatusDosen">
                    <b-form-radio value="utama">Utama</b-form-radio>
                    <b-form-radio value="cadangan">Cadangan</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </b-modal>

        <b-modal id="modal-edit" size="lg" title="Edit Dosen Mata Pelajaran" ok-title="Simpan" ok-variant="primary"
          cancel-title="Batal" cancel-variant="danger">
          <b-form>
            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Bidang Studi">
                  <b-form-input id="editBidangStudi" type="text" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Mata Kuliah">
                  <b-form-input id="editMataKuliah" type="number" required></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Mata Pelajaran">
                  <b-form-input id="editMataPelajaran" type="text" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Nama Dosen">
                  <SelectDosen></SelectDosen>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Status Dosen">
                  <b-form-radio-group id="editStatusDosen">
                    <b-form-radio value="utama">Utama</b-form-radio>
                    <b-form-radio value="cadangan">Cadangan</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </b-modal>
        <!-- content end -->

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SelectBidangStudi from "@/view/content/components/select/SelectBidangStudi.vue";
import SelectMataKuliah from "@/view/content/components/select/SelectMataKuliah.vue";
import SelectMataPelajaran from "@/view/content/components/select/SelectMataPelajaran.vue";
import SelectDosen from "@/view/content/components/select/SelectDosen.vue";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";

export default {
  data() {
    return {
      dosenMatpel: {
        // html: `<v-card>
        //         <v-card-title>Nutrition
        //             <v-spacer></v-spacer>
        //             <v-text-field v-model="search"
        //                 append-icon="search"
        //                 label="Search"
        //                 single-line
        //                 hide-details
        //             ></v-text-field>
        //         </v-card-title>
        //         <v-data-table
        //             :headers="headers"
        //             :items="desserts"
        //             :search="search"
        //         ></v-data-table>
        //         </v-card>`,
        // js: ` export default {
        //         data () {
        //             return {
        //             search: '',
        //             headers: [
        //                 {
        //                     { text: "No", value: "no" },
        //                     { text: "Kode", value: "kode" },
        //                     { text: "Mata Kuliah", value: "mataKuliah" },
        //                     { text: "SKS", value: "sks" },
        //                     { text: "Aksi", value: "action" 
        //                 }
        //             ],
        //             desserts: [
        //                 {
        //                     no: 1,
        //                     kode: "BS 001 MK001",
        //                     mataKuliah: "Probabilitas Statistika",
        //                     sks: 2
        //                 },
        //                 {
        //                     no: 2,
        //                     kode: "BS 002 MK002",
        //                     mataKuliah: "Arsitektur Komputer",
        //                     sks: 2
        //                 },
        //                 {
        //                     no: 3,
        //                     kode: "BS 003 MK003",
        //                     mataKuliah: "Matematika Diskret",
        //                     sks: 1
        //                 },
        //                 {
        //                     no: 4,
        //                     kode: "BS 004 MK004",
        //                     mataKuliah: "Aplikasi Komputer",
        //                     sks: 3
        //                 }
        //             ],
        //             }
        //         },
        //     }`,
        search: "",
        headers: [
          { text: "No", align: "center", value: "no" },
          { text: "Nama Dosen", align: "center", value: "nama_dosen" },
          { text: "Status Dosen", align: "center", value: "status_dosen" },
          { text: "Aksi", align: "center", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            nama_dosen: "Dr. Ing. Widodo Pranowo",
            status_dosen: "Utama"
          },
          {
            no: 2,
            nama_dosen: "Dr. Ing. Widodo Pranowo",
            status_dosen: "Utama"
          },
          {
            no: 3,
            nama_dosen: "Dr. Ing. Widodo Pranowo",
            status_dosen: "Cadangan"
          },
          {
            no: 4,
            nama_dosen: "Dr. Ing. Widodo Pranowo",
            status_dosen: "Utama"
          },
          {
            no: 5,
            nama_dosen: "Dr. Ing. Widodo Pranowo",
            status_dosen: "Utama"
          },
        ]
      }
    };
  },
  components: {
    KTCodePreview,
    SelectBidangStudi,
    SelectMataKuliah,
    SelectMataPelajaran,
    SelectDosen,
    ButtonComponent,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Akademik" },
      { title: "Master Dosen Mata Pelajaran" }
    ]);
  }
}
</script>